import {createApp} from 'vue'
import './style.css'
import App from './App.vue'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';
import router from "./comm/router.ts";

import * as Sentry from "@sentry/vue";


const app = createApp(App);

Sentry.init({
    app,
    dsn: "https://1931d1863a31c86a9d3028a19625f174@o4508821480669184.ingest.de.sentry.io/4508821486370896",
    integrations: [
        Sentry.browserTracingIntegration({router}),
        Sentry.replayIntegration(),
    ],
    enabled: import.meta.env.MODE !== 'development',
    environment: import.meta.env.MODE,
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/bangchu\.dreace\.top/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});


app.use(Antd)
    .use(router)
    .mount('#app');
